import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";

export const GlobalSearch = ({ sections }) => {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen((o) => !o); }
    };
    const onOpen = () => setOpen(true);
    window.addEventListener("keydown", onKey);
    window.addEventListener("lim:open-search", onOpen);
    return () => { window.removeEventListener("keydown", onKey); window.removeEventListener("lim:open-search", onOpen); };
  }, []);
  const go = (to) => { setOpen(false); nav(to); };
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="global-search-trigger"
        className="hidden sm:flex items-center gap-2 h-9 w-full max-w-md px-3 rounded-md border border-white/10 bg-surface2/60 text-sm text-white/45 hover:border-white/20 transition-colors"
      >
        <Search size={15} />
        <span className="flex-1 text-left">Search pages…</span>
        <kbd className="text-[0.7rem] font-mono border border-white/15 rounded px-1.5 py-0.5">S</kbd>
      </button>
      <button type="button" onClick={() => setOpen(true)} data-testid="global-search-trigger-mobile"
        className="sm:hidden h-9 w-9 grid place-items-center rounded-md text-white/70 hover:bg-white/5" aria-label="Search">
        <Search size={17} />
      </button>
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Jump to a page…" data-testid="global-search-input" />
        <CommandList>
          <CommandEmpty>No matching page.</CommandEmpty>
          {sections.map((s) => (
            <CommandGroup key={s.title} heading={s.title}>
              {s.items.map((it) => (
                <CommandItem key={it.to} value={`${s.title} ${it.label}`} onSelect={() => go(it.to)}
                  data-testid={`global-search-item-${it.to.replace(/\W+/g, "-") || "home"}`}>
                  <it.icon size={15} className="mr-2" /> {it.label}
                </CommandItem>
              ))}
            </CommandGroup>
          ))}
        </CommandList>
      </CommandDialog>
    </>
  );
};
